export default __webpack_public_path__ + "static/media/Wildstrider Helm.3f8c38f1.jpg";